import { useETFHoldingsQuery } from '../hooks'
import { ETFHoldingsWidgetNavigation } from '../types'
import { Navigation } from './Navigation'

export function Header({
  query,
  widgetType,
}: {
  query: ReturnType<typeof useETFHoldingsQuery>
  widgetType: ETFHoldingsWidgetNavigation
}) {
  return (
    <div className="flex h-10 shrink-0 grow-0 items-center justify-between px-3 text-sm text-muted">
      <div>{widgetType.title}</div>
      <div className="flex">
        <Navigation navType={widgetType.navType} query={query} viewTypes={widgetType.viewTypes} />
      </div>
    </div>
  )
}
